import * as React from 'react';

export default () => (
  <div className="row">
    <br/><br/>
    <br/><br/>
    <br/><br/>
    <div className="col s5">&nbsp;</div>
    <div className="col s2">
      <div className="preloader-wrapper big active">
        <div className="spinner-layer spinner-blue-only">
          <div className="circle-clipper left">
            <div className="circle"></div>
          </div><div className="gap-patch">
            <div className="circle"></div>
          </div><div className="circle-clipper right">
            <div className="circle"></div>
          </div>
        </div>
      </div>
    </div>
    <div className="col s5">&nbsp;</div>
  </div>
)



// WEBPACK FOOTER //
// ./src/shared/loader.tsx